/**
 * @ignore
 *
 * The actions for our store.
 * For more info on Redux actions, see <https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers#designing-actions>
 */
import {
    SET_USER
} from './actionTypes';


export function setUser(payload) {
    return {
        type: SET_USER,
        payload
    }
}
